import type { ReactNode } from 'react'

import { InviteMemberDialog } from '@/components/org-settings/members/invite-member-dialog.organism'
import type {
  InviteMemberFormData,
  OrganizationInvitation,
  OrganizationMember,
} from '@/components/org-settings/members/members.interface'

import { LeaveOrganizationDialog } from './leave-organization-dialog.atom'
import { RemoveMemberDialog } from './remove-member-dialog.atom'
import { RevokeInvitationDialog } from './revoke-invitation-dialog.atom'

interface MembersDialogsSectionProps {
  isInviteDialogOpen: boolean
  onInviteDialogOpenChange: (isOpen: boolean) => void
  onInvite: (data: InviteMemberFormData) => Promise<void>
  isInviting: boolean
  memberToRemove: OrganizationMember | null
  onRemoveDialogClose: () => void
  onRemoveConfirm: () => Promise<void>
  invitationToRevoke: OrganizationInvitation | null
  onRevokeDialogClose: () => void
  onRevokeConfirm: () => Promise<void>
  isLeaveDialogOpen: boolean
  onLeaveDialogOpenChange: (isOpen: boolean) => void
  onLeaveConfirm: () => Promise<void>
}

export const MembersDialogsSection: React.FC<MembersDialogsSectionProps> = (props): ReactNode => (
  <>
    <InviteMemberDialog
      isOpen={props.isInviteDialogOpen}
      onOpenChange={props.onInviteDialogOpenChange}
      onInvite={props.onInvite}
      isLoading={props.isInviting}
    />
    <RemoveMemberDialog
      member={props.memberToRemove}
      onClose={props.onRemoveDialogClose}
      onConfirm={props.onRemoveConfirm}
    />
    <RevokeInvitationDialog
      invitation={props.invitationToRevoke}
      onClose={props.onRevokeDialogClose}
      onConfirm={props.onRevokeConfirm}
    />
    <LeaveOrganizationDialog
      isOpen={props.isLeaveDialogOpen}
      onOpenChange={props.onLeaveDialogOpenChange}
      onConfirm={props.onLeaveConfirm}
    />
  </>
)

MembersDialogsSection.displayName = 'MembersDialogsSection'
